import { Injectable, inject } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable, map } from 'rxjs'
import { environment } from '../../environments/environment'

export interface Payment {
  id?: string | number

  paymentGatewayId?: string
  gatewayPaymentId?: string
  paymentId?: string

  status?: string

  businessId?: string | number

  business?: {
    id?: string | number
    businessName?: string
  }

  amount?: number

  paymentMethod?: string
  cardLast4?: string
  cardNetwork?: string
  cardType?: string
  cardIssuer?: string
  upiVpa?: string
  bankName?: string
  createdAt?: string
  updatedAt?: string

  [key: string]: any
}

export interface PaymentResponse {
  data?: Payment[]
  payments?: Payment[]
  results?: Payment[]

  totalCount?: number
  total?: number
  count?: number

  successfulCount?: number
  successCount?: number

  pendingCount?: number
  failedCount?: number

  [key: string]: any
}

@Injectable({
  providedIn: 'root'
})
export class EarningsService {
  private http = inject(HttpClient)

  private apiUrl = `${environment.apiBaseUrl}/payments`

  getPayments(params: {
    page?: number
    limit?: number
    businessId?: string | null
    status?: string | null
    search?: string
  }): Observable<PaymentResponse> {
    let httpParams = new HttpParams()

    if (params.page !== undefined) {
      httpParams = httpParams.set('page', params.page.toString())
    }

    if (params.limit !== undefined) {
      httpParams = httpParams.set('limit', params.limit.toString())
    }

    if (params.businessId) {
      httpParams = httpParams.set('businessId', params.businessId.toString())
    }

    if (params.status !== null && params.status !== undefined && params.status !== '') {
      httpParams = httpParams.set('status', params.status)
    }

    if (params.search?.trim()) {
      httpParams = httpParams.set('search', params.search.trim())
    }

    return this.http.get<PaymentResponse>(this.apiUrl, {
      params: httpParams
    })
  }
}
